import React, { useEffect } from 'react';
// Remove the useLocation import since it's causing problems
import { quizStore } from '@/store/quizStore';
import { ensureSignedInForOfficeHost } from '@/lib/auth';
import DebugButton from '@/components/DebugButton';
import { APP_VERSION } from '@/version';
import KeyboardHelpOverlay from './components/KeyboardHelpOverlay';

export default function WebsiteShell({ children }: { children: React.ReactNode }) {
  // Remove the dependency on useLocation
  useEffect(() => {
    // Initialize without checking the path
    // TEMPORARILY DISABLED: Auto sign-in for Office host to debug logout issue
    quizStore
      .init()
      // .then(() => ensureSignedInForOfficeHost())
      .catch(console.error);
  }, []);

  return (
    <>
      {children}
      <KeyboardHelpOverlay />
      <DebugButton />
      <div
        className="print:hidden"
        style={{
          position: 'fixed',
          left: 8,
          bottom: 6,
          fontSize: 11,
          opacity: 0.6,
          color: 'var(--qq-muted, #666)',
          zIndex: 9998,
          pointerEvents: 'none',
        }}
      >
        v{APP_VERSION}
      </div>
    </>
  );
}

